import { render } from "./gainClass.vue?vue&type=template&id=40c9ca1c&scoped=true&ts=true"
import script from "./gainClass.vue?vue&type=script&lang=ts"
export * from "./gainClass.vue?vue&type=script&lang=ts"

import "./gainClass.vue?vue&type=style&index=0&id=40c9ca1c&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9ca1c"]])

export default __exports__